import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/contexts/AuthContext';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HomePage from '@/pages/HomePage';
import SearchPage from '@/pages/SearchPage';
import PropertyDetailPage from '@/pages/PropertyDetailPage';
import LoginPage from '@/pages/LoginPage';
import RegisterPage from '@/pages/RegisterPage';
import PublishPropertyPage from '@/pages/PublishPropertyPage';
import ProfilePage from '@/pages/ProfilePage';
import AdminPage from '@/pages/AdminPage';
import AdminPaymentPlansPage from '@/pages/AdminPaymentPlansPage';
import AdminCouponsPage from '@/pages/AdminCouponsPage';
import PaymentPage from '@/pages/PaymentPage';
import PaymentResultPage from '@/pages/PaymentResultPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className='min-h-screen flex flex-col'>
          <Header />
          <main className='flex-1'>
            <Routes>
              <Route path='/' element={<HomePage />} />
              <Route path='/buscar' element={<SearchPage />} />
              <Route path='/inmueble/:slug' element={<PropertyDetailPage />} />
              <Route
                path='/propiedad/:id'
                element={<PropertyDetailPage />}
              />{' '}
              {/* Legacy route */}
              <Route path='/iniciar-sesion' element={<LoginPage />} />
              <Route path='/login' element={<LoginPage />} />{' '}
              {/* Legacy route */}
              <Route path='/registro' element={<RegisterPage />} />
              <Route
                path='/publicar-propiedad'
                element={<PublishPropertyPage />}
              />
              <Route path='/publicar' element={<PublishPropertyPage />} />{' '}
              {/* Legacy route */}
              <Route path='/mi-cuenta' element={<ProfilePage />} />
              <Route path='/perfil' element={<ProfilePage />} />{' '}
              {/* Legacy route */}
              <Route path='/admin' element={<AdminPage />} />
              <Route
                path='/admin/planes-pago'
                element={<AdminPaymentPlansPage />}
              />
              <Route
                path='/admin/payment-plans'
                element={<AdminPaymentPlansPage />}
              />{' '}
              {/* Legacy route */}
              <Route path='/admin/cupones' element={<AdminCouponsPage />} />
              <Route
                path='/admin/coupons'
                element={<AdminCouponsPage />}
              />{' '}
              {/* Legacy route */}
              <Route path='/pagos' element={<PaymentPage />} />
              <Route path='/pago/exitoso' element={<PaymentResultPage />} />
              <Route path='/pago/fallido' element={<PaymentResultPage />} />
              <Route path='/pago/pendiente' element={<PaymentResultPage />} />
              <Route
                path='/payment/success'
                element={<PaymentResultPage />}
              />{' '}
              {/* Legacy route */}
              <Route
                path='/payment/failure'
                element={<PaymentResultPage />}
              />{' '}
              {/* Legacy route */}
              <Route
                path='/payment/pending'
                element={<PaymentResultPage />}
              />{' '}
              {/* Legacy route */}
            </Routes>
          </main>
          <Footer />
        </div>
        <Toaster position='top-right' richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
